module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm7"
    }
  }, [_c('p', {
    staticClass: "comment"
  }, [_c('span', [_vm._v("The author would like to thank Jacqueline Kennedy Onassis for her good advice and encourage, ment. And also Judy Sandman, Craig Mueller, and Paul Ross Leslie for their careful attention to the book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-488c871a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment.vue
// module id = 81
// module chunks = 0